export default "__VITE_ASSET__C$RmqMAT__"